<!-- Карточка ресурса с правами и настройками видимости для одной роли. -->
<template>
  <div class="resource-card">
    <div class="resource-card-header">
      <span class="resource-name">
        {{ resource.label }}
      </span>

      <PermissionRoleGroupBadges :groups="resourceGroups" />
    </div>

    <div v-if="plainPermissions.length" class="resource-chips">
      <PermissionRoleToggleButton
        v-for="permission in plainPermissions"
        :key="permission.action"
        :label="permission.label"
        :selected="permission.value"
        :disabled="disabled"
        @click="$emit('toggle-permission', resource.target_resource, permission.action)"
      />
    </div>

    <PermissionRoleDataScopeSettings
      :data-scope="resource.data_scope"
      :disabled="disabled"
      @change="$emit('change-data-scope', resource.target_resource, $event)"
    />

    <PermissionRoleActionSection
      v-for="section in permissionSections"
      :key="section.key"
      :section="section"
      :disabled="disabled"
      @toggle="$emit('toggle-permission', resource.target_resource, $event)"
    />
  </div>
</template>

<script>
import PermissionRoleActionSection from "@/components/PermissionRole/ActionSection.vue";
import PermissionRoleDataScopeSettings from "@/components/PermissionRole/DataScopeSettings.vue";
import PermissionRoleGroupBadges from "@/components/PermissionRole/GroupBadges.vue";
import PermissionRoleToggleButton from "@/components/PermissionRole/ToggleButton.vue";

const FALLBACK_GROUP_KEY = "other";
const FALLBACK_GROUP_LABEL = "Другое";

export default {
  name: "PermissionRoleResourceCard",

  components: {
    PermissionRoleActionSection,
    PermissionRoleDataScopeSettings,
    PermissionRoleGroupBadges,
    PermissionRoleToggleButton,
  },

  props: {
    resource: {
      type: Object,
      required: true,
    },
    disabled: Boolean,
  },

  emits: ["toggle-permission", "change-data-scope"],

  computed: {
    plainPermissions() {
      return this.resource.permissions.filter(
        (permission) => !permission.section
      );
    },

    permissionSections() {
      const sectionsByKey = new Map();

      this.resource.permissions.forEach((permission) => {
        if (!permission.section) return;

        const section = sectionsByKey.get(permission.section.key) || {
          ...permission.section,
          permissions: [],
        };

        section.permissions.push(permission);
        sectionsByKey.set(section.key, section);
      });

      return Array.from(sectionsByKey.values());
    },

    resourceGroups() {
      if (this.resource.groups?.length) {
        return this.resource.groups;
      }

      return [
        {
          group: this.resource.group || FALLBACK_GROUP_KEY,
          label: this.resource.group_label || FALLBACK_GROUP_LABEL,
          emoji: this.resource.group_emoji,
          position: null,
        },
      ];
    },
  },
};
</script>

<style scoped>
.resource-card {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 14px 16px;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  background: #fff;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.resource-card:hover {
  border-color: #d1d5db;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.resource-card-header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}

.resource-name {
  color: var(--color-dark);
  font-size: 14px;
  font-weight: 600;
}

.resource-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

@media (max-width: 768px) {
  .resource-card {
    gap: 12px;
  }

  .resource-chips {
    gap: 10px;
  }
}
</style>
